import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { MatDialog } from '@angular/material';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ValidationService } from '../validation.service';
import { EditVehicleComponent } from '../vehicles/edit-vehicle/edit-vehicle.component';
import { ViewVehicleComponent } from '../vehicles/view-vehicle/view-vehicle.component';
import { AttachDriverComponent } from '../attach-driver/attach-driver.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { TimeService } from '../time.service';
import { FilterModalComponent } from './filter-modal/filter-modal.component';
declare var google: any;

@Component({
  selector: 'app-own-vehicle-map-view',
  templateUrl: './own-vehicle-map-view.component.html',
  styleUrls: ['./own-vehicle-map-view.component.scss']
})
export class OwnVehicleMapViewComponent implements OnInit {

  @ViewChild('uploadDialog', { static: true }) uploadDialog: TemplateRef<any>;
  @ViewChild('markMaintainance', { static: true }) markMaintainance: TemplateRef<any>;

  showLoader = false;
  map;
  min_due_date;
  filterVehicle;
  allVehicles = true;
  vehiclesList;
  bounds;
  mapMarkers: any = [];
  uploadDocsRef: any;
  fileLength = 0;
  vehicleId = '';
  current_unit = true;
  all_units = false;
  regFormData = new FormData();
  selectedStatus: any = 'NA';
  markerCluster: MarkerClusterer;
  vehicle_filters: any = {

  }
  countFilters: any = {
    enterprise_level: false
  }
  isSearch = false;
  searchTextChanged = new Subject<object>();
  subscription: Subscription;

  due_date: any
  due_date_string;
  selected_vehicle_data;
  showYesNo;
  mark_type: any;
  markMaintainanceRef: any;




  truckIcon = {
    url: 'assets/truck-icon.svg',
    scaledSize: new google.maps.Size(30, 30)
  };
  picon = {
    url: 'assets/Pickup.svg', // url
    scaledSize: new google.maps.Size(30, 30)
  };
  green;
  description:any=[];
  vehicles_array = [];
  vehiclesArray = [];
  vehicle_stats: any = {
    on_shipment: 0,
    free: 0,
    total: 0
  }
  unitLocation: any = {};
  carrier_id;
  total_selected = true;
  on_shipment_selected = false;
  free_selected = false;
  carrierUpdates: Subscription
  selectDedicated = false;
  selectUnit = 'current_unit';

  constructor(private http: HttpService, private snackBar: SnackbarService, private dialog: MatDialog, private events: EventService, private storage: StorageService, private route: Router,
    private changeDetection: ChangeDetectorRef, private translation: TranslateService,
    private snackbar: SnackbarService, private valid: ValidationService, private timeserive: TimeService) { }

  ngOnInit() {
    let carriers = JSON.parse(localStorage.getItem('carriers'));
    this.carrier_id = carriers[0]._id;
    this.initMap();
    this.vehicle_filters.enterprise_level = false;
    this.countFilters.enterprise_level = false;
    this.getVehicleStats();
    this.getVehicles(this.vehicle_filters);
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.refreshMapView();
      }
    );
  }

  ngOndestroy() {
    this.carrierUpdates.unsubscribe();
  }

  getVehicleStats(filter: any = {}) {

    // let enterprise_level=fase;

    //  if(this.selectUnit == 'current_unit'){
    //   this.vehicle_filters.enterprise_level = false;
    //   }else{
    //     this.vehicle_filters.enterprise_level = false;
    //   }

    let payload = {
      enterprise_level: this.countFilters.enterprise_level,
      dedicated_to: this.selectDedicated,
    }

    if(this.vehicle_filters.carriers){
      payload['carriers'] = this.vehicle_filters.carriers;
    }
    if(this.vehicle_filters.distance_filter){
      payload['distance_filter'] = this.vehicle_filters.distance_filter;
    }

    if(this.vehicle_filters.location){
      payload['location'] = this.vehicle_filters.location;
    }
    this.http.post('vehicle/get_count_carriers', payload, 3).subscribe(
      (data: any) => {
        if (data && data.statusCode == 200) {
          this.vehicle_stats.free = data.data.detached || 0;
          this.vehicle_stats.on_shipment = data.data.attached || 0;
          this.vehicle_stats.total = this.vehicle_stats.free + this.vehicle_stats.on_shipment;
        }
      }
    );
  }


  refreshMapView() {
    this.total_selected = true;
    this.on_shipment_selected = false;
    this.free_selected = false;

    this.getVehicleStats();
    this.getVehicles(this.vehicle_filters);
  }

  removeMarkers(markers) {
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
      this.markerCluster.removeMarkers(markers)
    }

    markers.forEach(element => {
      element.setMap(null);
    });
    this.mapMarkers = [];
  }

  getVehicles(filter: any = {}) {
    this.showLoader = true;
    if (filter.attached_driver == 'NA') {
      delete filter.attached_driver;
    }
    // filter.limit =  this.paginator.pageSize || 25;
    // filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    (this.isSearch) ? this.vehicles_array = [] : '';
    this.http.post('vehicle/get_by_status_carriers', filter, 3).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode == 200) {
          this.vehiclesArray = data.data;
          if (this.mapMarkers.length) {
            this.removeMarkers(this.mapMarkers);
          }
          this.vehicles_array = [];
          this.vehiclesArray.forEach((element, index) => {
            const temp: any = {
              vehicle: {},
              tank: {},
              registration: {},
              gps: {}
            }

            temp._id = element._id;
            temp.vehicle.name = element.type.name;
            temp.vehicle._id = element.type._id;
            temp.tank.mileage = element.tank ? element.tank.mileage : 0;
            temp.tank.mileage_unit = element.tank ? element.tank.mileage_unit : '';
            temp.tank.capacity = element.tank ? element.tank.capacity : 0;
            temp.tank.capacity_unit = element.tank ? element.tank.capacity_unit : '';
            temp.registration.year = element.registration ? element.registration.year : 0;
            temp.registration.chassis_number = element.registration ? element.registration.chassis_number : '';
            temp.registration.engine_number = element.registration ? element.registration.engine_number : 0;
            temp.vehicleNumber = element.REG_number;
            temp.gps.id = element.gps ? element.gps.id : '';
            temp.gps.provider = element.gps ? element.gps.provider : '';
            temp.bodyType = element.type.body_type;
            temp.vehicle_pic = element.vehicle_pic ? element.vehicle_pic.original : '';
            temp.in_shipment = element.in_shipment;
            temp.attached = (element.attached_driver && element.attached_driver.length) ? true : false;
            temp.maintenance = element.maintenance ? element.maintenance.in_service : false;
            temp.maintenance_due_date = element.maintenance ? element.maintenance.due_date : '';
            temp.shipper_unit = element.shipper_unit ? element.shipper_unit.name : '';
            temp.usageIndicator_code = element.usageIndicator ? element.usageIndicator.code : '';
            temp.carrier_name = element.carrier_unit ? element.carrier_unit.parent_name : '';
            temp.attached_driver_data = element.attached_driver ? element.attached_driver[0] : '';
            if (temp.in_shipment) {
              temp.trip_status = "In Shipment";
            } else if (temp.attached) {
              temp.trip_status = "Attached";
            } else {
              temp.trip_status = "Free";
            }
            if (temp.attached_driver_data) {
              temp.driverName = (temp.attached_driver_data.driver) ? temp.attached_driver_data.driver.name : '';
              temp.driverMobile = (temp.attached_driver_data.driver) ? temp.attached_driver_data.driver.mobile : '';
              temp.last_online_time = temp.attached_driver_data.last_online_time;
              if (temp.attached_driver_data.geo_point) {
                temp.current_location = {
                  longitude: temp.attached_driver_data.geo_point.coordinates[0],
                  latitude: temp.attached_driver_data.geo_point.coordinates[1]
                }
              }
            } else {
              temp.driverName = '';
              temp.driverMobile = '';
              temp.current_location = {
                longitude: element.geo_point.coordinates[0],
                latitude: element.geo_point.coordinates[1]
              }
            }

            this.vehicles_array.push(temp);
          });
          this.bounds = new google.maps.LatLngBounds();
          this.plotVehicles(this.vehicles_array);
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );

  }

  diff_minutes(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  initMap(lat = 12.960691, lng = 77.580116) {
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    };
    this.map = new google.maps.Map(document.getElementById('vehicleMap'), mapProp);
  }

  plotVehicles(vehicles) {
    if (vehicles.length) {
      vehicles.forEach(element => {
        if (element.current_location) {
          if (element.current_location.latitude && element.current_location.longitude) {
            let content = element.vehicleNumber ? 'Vehicle Number: ' + element.vehicleNumber : '';
            if(element.carrier_name){
              content += '<br>Carrier: ' + element.carrier_name;
            }
            if(element.driverName) {
              content += '<br>Driver: ' + element.driverName;
            }
            if(element.driverMobile) {
              content += '<br>Mobile: ' + element.driverMobile;
            }
            // content += '<br>' + element.driverName ? 'Driver Name: ' + element.driverName : '';
            // content += '<br>' + element.csrrier_unit ? element.carrier_unit.parent_name : '';
            const latLng = { lat: parseFloat(element.current_location.latitude), lng: parseFloat(element.current_location.longitude) };
            this.placeMarker(element.current_location, '', this.truckIcon, content);
            this.bounds.extend(latLng);
            this.map.fitBounds(this.bounds);
          }
        }
      });

      // this.markerCluster = new MarkerClusterer(this.map, this.mapMarkers, {
      //   imagePath:
      //     'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      // });
      this.markerCluster = new MarkerClusterer({
        map: google.maps.Map,
        markers: this.mapMarkers,
      })
    } else {
      this.map.setZoom(11);
    }
    this.getUnitLocation();
  }

  panToVehicle(address) {
    if (address.current_location) {
      let position = { lat: address.current_location.latitude, lng: address.current_location.longitude }
      this.map.setZoom(18);
      this.map.panTo(position);
    }
  }

  resetMap() {
    this.removeMarkers(this.mapMarkers);
    this.plotVehicles(this.vehicles_array);
  }

  getUnitLocation() {
    let payload = {
      carrier: this.carrier_id
    }
    this.http.get('shipper/unitLocation', payload).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          const response = data.data.entity;
          if (response[0].location) {
            this.unitLocation.latitude = response[0].location.geo_point ? response[0].location.geo_point.coordinates[1] : '';
            this.unitLocation.longitude = response[0].location.geo_point ? response[0].location.geo_point.coordinates[0] : '';
          }
          if (this.unitLocation.latitude && this.unitLocation.longitude) {
            const latLng = { lat: parseFloat(this.unitLocation.latitude), lng: parseFloat(this.unitLocation.longitude) };
            this.placeMarker(this.unitLocation, 'U', this.picon);
            this.bounds.extend(latLng);
            this.map.fitBounds(this.bounds);
          }
        }
      }
    );
  }

  placeMarker(location, label = '', icon: any = '', content: any = '') {
    const markerOpt: any = {
      position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
      map: this.map,
      label: label ? { text: label, color: "#fff" } : null,
    };
    (icon) ? markerOpt.icon = icon : '';

    const marker = new google.maps.Marker(markerOpt);
    if (content) {
      const infowindow = new google.maps.InfoWindow({
        content: content,
        maxWidth: 300
      });
      google.maps.event.addListener(marker, 'mouseover', function () {
        infowindow.open(map, marker);
      });
      google.maps.event.addListener(marker, 'mouseout', function () {
        infowindow.close(map, marker);
      });
    }
    this.mapMarkers.push(marker);
    marker.setMap(this.map);
  }

  openEditVehicleComponent(element) {
    const dialogRef = this.dialog.open(EditVehicleComponent, {
      data: element
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getVehicleStats();
        this.vehicle_filters.attached_driver = this.selectedStatus;
        this.getVehicles(this.vehicle_filters);
      }
    });
  }

  //view vehicle details
  openViewVehicle(vehicle) {
    const dialogRef = this.dialog.open(ViewVehicleComponent, {
      data: vehicle
    });
  }
  openAttachDriverComponent(data, type) {
    if (type == 'Attach') {
      const dialogRef = this.dialog.open(AttachDriverComponent, {
        data: data._id
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.statusCode == 200 || result == 'yes') {
          this.getVehicleStats();
          this.vehicle_filters.attached_driver = this.selectedStatus;
          this.getVehicles(this.vehicle_filters);
        }
      });
    } else if (type == 'Detach') {
      const dialogData = {
        name: 'Detach Driver',
        text: this.translation.instant('Do you want to detach Driver?'),
        driver_id: data.attached_driver_data._id,
        url: 'driver/detach'
      }
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.statusCode == 200 || result == 'yes') {
          this.getVehicleStats();
          this.vehicle_filters.attached_driver = this.selectedStatus;
          this.getVehicles(this.vehicle_filters);
        }
      });
    }
  }
  fileChanged(event: any) {
    if (event.target.files.length && (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png')) {
      this.fileLength = event.target.files.length;
      for (let x = 0; x < this.fileLength; x++) {
        this.regFormData.append('vehiclePic', event.target.files[x]);
      }
    } else {
      this.snackbar.openSnackBar(this.translation.instant('VEHICLE.image'), '', 'err');
      this.regFormData.delete('vehiclePic');
    }
  }

  openUploadDialog(element) {
    this.regFormData = new FormData();
    this.vehicleId = element._id;
    this.uploadDocsRef = this.dialog.open(this.uploadDialog);
    this.uploadDocsRef.afterClosed().subscribe((data) => {
      if (data && data.statusCode == 200) {
        this.getVehicleStats();
        this.vehicle_filters.attached_driver = this.selectedStatus;
        this.getVehicles(this.vehicle_filters);
      }
    })
  }

  uploadRegDocs(element) {

    if (this.fileLength > 0) {
      this.showLoader = true;
      this.http.upload('v2/vehicle/upload/' + this.vehicleId, this.regFormData, 3).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.translation.instant('VEHICLE.docsUpload'), '');
            this.vehicleId = '';
            this.fileLength = 0;
            this.uploadDocsRef.close(data);
            this.regFormData = new FormData();
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          this.regFormData = new FormData();
        }
      );
    } else {
      this.snackbar.openSnackBar(this.translation.instant('VEHICLE.image'), '', 'err');
    }
  }

  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    switch (type) {
      case 'vehicle_number':
        (value.length >= 3) ? this.vehicle_filters.number = value : (value.length == 0) ? this.clearFilter() : ''; // if search input is empty get all the shipments else with the filter
        this.isSearch = true;
        break;
      default:
        this.clearFilter();
        break;
    }
    this.reSubscribe();
    this.searchTextChanged.next(this.vehicle_filters);
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.getVehicles(x);
      this.getVehicleStats();
    });
    this.changeDetection.detectChanges();
  }

  clearFilter() {
    this.isSearch = false;
    this.getVehicleStats();
    delete this.vehicle_filters.number;
    this.filterVehicle = '';
    this.vehicle_filters.attached_driver = this.selectedStatus;
    this.getVehicles(this.vehicle_filters);
  }

  openMarkMaintainanceDialog(element, type) {
    this.selected_vehicle_data = element;
    this.mark_type = type;
    this.min_due_date = new Date();
    this.showYesNo = this.mark_type == 'markIn' ? true : false;
    this.vehicleId = element._id;
    this.markMaintainanceRef = this.dialog.open(this.markMaintainance);
    this.markMaintainanceRef.afterClosed().subscribe((data) => {
      if (data && data.statusCode == 200) {
        this.vehicle_filters.attached_driver = this.selectedStatus;
        this.getVehicles(this.vehicle_filters);
      }
    })
  }

  getEpoch(value) {
    this.due_date = this.timeserive.toUTCEpoch(value);
  }

  closeModal(data: any) {
    this.due_date = '';
    this.due_date_string = '';
    this.markMaintainanceRef.close(data)
  }

  changeRadio(data) {
    if (data == 'current_unit') {
      this.current_unit = true;
      this.all_units = false;
      this.vehicle_filters.enterprise_level = false;
      this.countFilters.enterprise_level = false;

      this.getVehicleStats();
      this.getVehicles(this.vehicle_filters)
    } else {
      this.current_unit = false;
      this.all_units = true;
      this.vehicle_filters.enterprise_level = true;
      this.countFilters.enterprise_level = true;
      this.selectDedicated = false;
      this.getVehicleStats();
      this.getVehicles(this.vehicle_filters);
    }
  }

  markMaintainanceSubmit() {
    let url;
    const payload: any = {
      vehicle_id: this.selected_vehicle_data._id
    };
    if (this.selected_vehicle_data.maintenance) {
      url = "/v1/vehicle/out_of_maintainance";
      if (this.due_date) {
        payload.maintainance_due_date = this.due_date;
      }
    } else {
      url = "/v1/vehicle/in_maintainance";
    }
    this.showLoader = true;
    this.http.post(url, payload, 3).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.showLoader = false;
        if (this.selected_vehicle_data.maintenance) {
          this.snackbar.openSnackBar(this.translation.instant('VEHICLE.maintenanceOut_success'));
        } else {
          this.snackbar.openSnackBar(this.translation.instant('VEHICLE.maintenanceIn_success'));
        }
        this.closeModal(response);
      }
    },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      })
  }
  dedicatedcheck() {

    this.vehicle_filters.enterprise_level = false;
    this.vehicle_filters.dedicated_to = this.selectDedicated;
    this.getVehicles(this.vehicle_filters);
    this.getVehicleStats();
  }

  openAdvanceSearch() {
    const advanceSearchRef = this.dialog.open(FilterModalComponent);
    advanceSearchRef.afterClosed().subscribe((data) => {
        if (data) {
          this.vehicle_filters['distance_filter'] = data.range;
          this.vehicle_filters['carriers'] = data.carriers;
          this.vehicle_filters['location'] = data.location;
          this.getVehicles(this.vehicle_filters);
          this.getVehicleStats(this.vehicle_filters);
        }
      },
      (err) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  filterData() {


    if (this.selectUnit == 'current_unit') {
      this.vehicle_filters.enterprise_level = false;
      this.countFilters.enterprise_level = false;
    } else {
      this.vehicle_filters.enterprise_level = true;
      this.countFilters.enterprise_level = true;
    }

    this.vehicle_filters.dedicated_to = this.selectDedicated;
    this.vehicle_filters.attached_driver = this.selectedStatus;

    this.getVehicles(this.vehicle_filters);
    this.getVehicleStats();

  }

}
